// This are all the available sections for the application details
import PayrollInfo from './PayrollInfo'

export {
  PayrollInfo
}
